import { Box, styled } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(8, 0),
  padding: theme.spacing(6, 14),
}));
